import { Flex, Button, Badge } from "@chakra-ui/react";
import { FiChevronRight } from "react-icons/fi";
import { openLinkInNewTab } from "utils";

type Props = {
  id: string;
  type: string;
  links: {
    addLiquidity?: string;
    swap?: string;
    supply?: string;
    borrow?: string;
    deposit?: string;
  };
  trackEventDefi?: (v: string) => void;
};

const Actions = ({ type, links, trackEventDefi }: Props) => {
  const handleClick = (link: string | undefined) => {
    openLinkInNewTab(link);
  };

  if (type === "dex") {
    return (
      <Flex
        gap="4"
        justify={{ base: "center", lg: "flex-end" }}
        flex="1"
        align="center"
      >
        <Button
          rightIcon={<FiChevronRight />}
          size="sm"
          fontSize="12"
          bg="brand.primary"
          color="brand.textWhite"
          flex={{ base: 1, md: "initial" }}
          onClick={() => {
            handleClick(links.addLiquidity);
            trackEventDefi && trackEventDefi("Add Liquidity");
          }}
          display={links.addLiquidity ? "inherit" : "none"}
        >
          ADD LIQUIDITY
        </Button>
        <Button
          rightIcon={<FiChevronRight />}
          borderRadius="6px"
          borderColor="brand.primaryLight"
          borderWidth="1px"
          size="sm"
          fontSize="12"
          flex={{ base: 1, md: "initial" }}
          onClick={() => {
            handleClick(links.swap);
            trackEventDefi && trackEventDefi("Swap");
          }}
          display={links.swap ? "inherit" : "none"}
          color="brand.primary"
          bg="brand.textWhite"
          _hover={{}}
          _dark={{
            bg: "brand.backgroundLight",
            color: "brand.textWhite",
          }}
        >
          SWAP
        </Button>
        <Badge
          mt="auto"
          fontSize="10px"
          lineHeight="12px"
          p="4px 8px"
          borderRadius="12px"
          _dark={{
            bg: "#3A3A3A",
          }}
          display={links.swap ? "none" : "block"}
        >
          Coming soon
        </Badge>
      </Flex>
    );
  }

  if (type === "lb") {
    return (
      <Flex
        gap="4"
        justify={{ base: "center", lg: "flex-end" }}
        flex="1"
        align="center"
      >
        <Button
          rightIcon={<FiChevronRight />}
          size="sm"
          fontSize="12"
          bg="brand.primary"
          color="brand.textLight"
          flex={{ base: 1, md: "initial" }}
          onClick={() => handleClick(links.supply)}
          display={links.supply ? "inherit" : "none"}
        >
          SUPPLY
        </Button>
        <Button
          variant="outline"
          rightIcon={<FiChevronRight />}
          size="sm"
          fontSize="12"
          flex={{ base: 1, md: "initial" }}
          onClick={() => handleClick(links.borrow)}
          display={links.borrow ? "inherit" : "none"}
        >
          BORROW
        </Button>
        <Badge
          mt="auto"
          fontSize="10px"
          lineHeight="12px"
          p="4px 8px"
          borderRadius="12px"
          display={links.borrow ? "none" : "block"}
        >
          Coming soon
        </Badge>
      </Flex>
    );
  }

  return (
    <Flex
      gap="4"
      justify={{ base: "center", lg: "flex-end" }}
      flex="1"
      align="center"
    >
      <Button
        rightIcon={<FiChevronRight />}
        size="sm"
        fontSize="12"
        bg="brand.primary"
        color="brand.textLight"
        flex={{ base: 1, md: "initial" }}
        onClick={() => openLinkInNewTab(links?.deposit)}
        display={links?.deposit ? "inherit" : "none"}
      >
        DEPOSIT
      </Button>
      <Badge
        fontSize="10px"
        lineHeight="12px"
        bg="#F7F1FF"
        color="#A570FF"
        p="4px 8px"
        borderRadius="12px"
        _dark={{
          bg: "#3A3A3A",
        }}
        alignSelf="center"
        display={links?.deposit ? "none" : "block"}
      >
        Coming soon
      </Badge>
    </Flex>
  );
};

export default Actions;
